import { Translator } from '@itarget/shared'

export const useTranslation = () => ({
  loading: Translator({ transRef: 'translation.Carregando os recursos.' }).props.children,
})
